module.exports = __webpack_public_path__ + "img/医疗-01.65d0fcd2.png";